import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import FAQs from './components/';
import { Helmet } from 'react-helmet';
import { initGA, pageview } from '../../utilities/gtag'; // Adjust path if needed

const index = () => {
  // useEffect(() => {
  //   document.title = 'Frequently Asked Questions - Matrimony Help';
  // }, []);
  useEffect(() => {
    initGA(); // Initialize GA once on mount
    pageview(window.location.pathname); // Track this pageview
  }, []);

  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions - Matrimony Help</title>
        <meta
          name="description"
          content="Get answers to your questions about using Elite Samskruti Matrimony. Learn how our AI technology improves matchmaking accuracy and ensures a safe, reliable experience."
        />
        <meta
          name="keywords"
          content="welcome, elite matrimony, matchmaking, Indian marriage"
        />
        <link rel="canonical" href="https://elite.lexyslabs.com/faqs" />

        {/* ✅ Add this robots meta tag here */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Elite Samskruti Matrimony | FAQs Page"
        />
        <meta
          property="og:description"
          content="Find your perfect match through India’s most trusted matchmaking platform."
        />
        <meta
          property="og:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
        <meta property="og:url" content="https://elite.lexyslabs.com/faqs" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elite Samskruti Matrimony" />
        <meta
          name="twitter:description"
          content="Where elite families find their perfect match."
        />
        <meta
          name="twitter:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
      </Helmet>
      <Layout sider={true}>
        <FAQs />
      </Layout>
    </>
  );
};

export default index;
